import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { selectors as operationSelectors } from 'ducks/uiOperations';
import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as dashboardMaintenanceActions, selectors as dashboardMaintenanceSelectors } from 'ducks/dashboardMaintenanceEnquiry/dashboardMaintenanceEnquiry';

import { buildSearchLookUpDrawer, ISearchLookUpDrawerProperties } from '../SearchLookUpDrawer';
import { IApplicationState } from 'ducks/reducers';

interface IPSEItem {
  Name: string;
  Description: string;
  DashboardId: number;
  DashboardType: string;
  '': string;
}

const DMESearchLookUpDrawer = buildSearchLookUpDrawer<IPSEItem>();

// We are declaring the props so that we get type-safety in the maps below.
type StateProps = Pick<ISearchLookUpDrawerProperties<IPSEItem>,
  'searchPlaceholder' | 'operationMode' | 'sortingFilters' | 'records' | 'selectedRecord' | 'selectedSortFilter' | 'selectedSortDirection' |
  'open' | 'isLoading' | 'nextPage' | 'prevPage' | 'pageSize' | 'totalPages' | 'loadingPrevPage' | 'loadingNextPage' |
  'keyField' | 'fieldsToDisplay' | 'searchParams' | 'variant' | 'getSearchFromMatchParams' | 'changeSelectedRecordCallBack' | 'searchTextProp'>;

type DispatchProps = Pick<ISearchLookUpDrawerProperties<IPSEItem>,
  'search' | 'searchById' | 'changeSelectedRecord' | 'onToggle' | 'fetchNextPage' | 'fetchPrevPage'>;

const mapStateToProps = (state: IApplicationState): StateProps => (
  {
    variant: 'DashboardMaintenanceEnquiry',
    searchPlaceholder: 'Search for dashboard...',
    operationMode: operationSelectors.operationMode(state),
    sortingFilters: [
      {
        filter: 'DashboardType',
        label: 'Dashboard type'
      }
    ],
    records: dashboardMaintenanceSelectors.all(state) || [],
    selectedRecord: dashboardMaintenanceSelectors.selected(state),
    selectedSortFilter: 'Name',
    selectedSortDirection: 'Ascending',
    open: uiSelectors.isDashboardMaintenanceEnquiryLookUpOpen(state),
    isLoading: dashboardMaintenanceSelectors.isLoading(state),
    nextPage: dashboardMaintenanceSelectors.nextPage(state),
    prevPage: dashboardMaintenanceSelectors.prevPage(state),
    pageSize: dashboardMaintenanceSelectors.pageSize(state),
    totalPages: dashboardMaintenanceSelectors.totalPages(state),
    loadingPrevPage: dashboardMaintenanceSelectors.loadingPrevPage(state),
    loadingNextPage: dashboardMaintenanceSelectors.loadingNextPage(state),
    keyField: 'DashboardId',
    fieldsToDisplay: {
      Row1: { description: 'Description', col2: 'DashboardActive' },
      Row2: { description: 'DashboardTypeDisplay' },
    },
    changeSelectedRecordCallBack: (matchParams: URLSearchParams, selectedRecord: any) => {
      if (selectedRecord) {
        matchParams.set('DashboardId', selectedRecord.DashboardId);
      }

      return matchParams.toString();
    },
    getSearchFromMatchParams: (matchParams: URLSearchParams) => {
      const DashboardId = Number(matchParams.get('DashboardId'));
      if (DashboardId) {
        return {
          id: DashboardId,
        };
      }

      return null;
    },
  });

const actionCreators: DispatchProps = {
  search: dashboardMaintenanceActions.search,
  searchById: dashboardMaintenanceActions.searchById,
  changeSelectedRecord: dashboardMaintenanceActions.setSelected,
  onToggle: uiActions.toggleDashboardMaintenanceEnquiryLookUp,
  fetchNextPage: dashboardMaintenanceActions.fetchNextPage,
  fetchPrevPage: dashboardMaintenanceActions.fetchPrevPage
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DMESearchLookUpDrawer);
